<div class="w-100-p border border-gray-300" *ngIf="dataSource">
    <mat-table #table [dataSource]="dataSource" matSort>
        <!-- Avatar Column -->
        <ng-container matColumnDef="avatar">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let scheduledStreamContent" class="avatar-cell cell-30 pl-20">
                <div #avatarCell>
                    <img class="avatar pointer" [src]="scheduledStreamContent.posting.image.url" />
                </div>
            </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.NAME' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let scheduledStreamContent" fxLayout="column" fxLayoutAlign="center start">
                <span class="text-truncate font-medium my-0 max-w-full" [matTooltip]="scheduledStreamContent.posting.translations[0].title" matTooltipPosition="above">
                    {{ scheduledStreamContent.posting.translations[0].title }}
                </span>
                <div fxLayout="row" fxLayoutAlign="flex-start center" class="mt-4" *ngIf="scheduledStreamContent.liveCategoryLink">
                    <mat-icon class="mr-8 text-gray-500">link</mat-icon>
                    <span class="text-truncate">{{ scheduledStreamContent.liveCategoryLink.category.name }}</span>
                </div>
            </mat-cell>
        </ng-container>

        <!-- Type Column -->
        <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.TYPE' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let scheduledStreamContent" fxLayout="column" fxLayoutAlign="center start">
                <span>{{ scheduledStreamContent.posting.postingType.displayNameKeySingular }}</span>
            </mat-cell>
        </ng-container>

        <!-- Valid From Column -->
        <ng-container matColumnDef="startDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.VALID_FROM' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let scheduledStreamContent" fxLayout="column" fxLayoutAlign="center start">
                <span>{{ scheduledStreamContent.startDate | date: 'shortDate' }}</span>
            </mat-cell>
        </ng-container>

        <!-- Valid To Column -->
        <ng-container matColumnDef="endDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.VALID_TO' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let scheduledStreamContent" fxLayout="column" fxLayoutAlign="center start">
                <span>
                    {{ (scheduledStreamContent.endDate | date: 'shortDate') || '-' }}
                </span>
            </mat-cell>
        </ng-container>

        <!-- Buttons Column -->
        <ng-container matColumnDef="buttons">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let scheduledStreamContent">
                <div fxFlex="row" fxLayoutAlign="end center">
                    <button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="More" (click)="$event.stopPropagation()">
                        <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
                    </button>

                    <mat-menu #moreMenu="matMenu" xPosition="before">
                        <app-menu-item-button
                            [icon]="'edit'"
                            [label]="'GENERAL.BUTTON.EDIT_VALIDITY_PERIOD'"
                            (onClick)="openScheduleFeaturedContentDialog(scheduledStreamContent)"
                        ></app-menu-item-button>
                        <app-menu-item-button [icon]="'delete'" [label]="'GENERAL.BUTTON.REMOVE'" (onClick)="onDeleteScss(scheduledStreamContent)"></app-menu-item-button>
                    </mat-menu>
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let user; columns: displayedColumns" class="user" matRipple> </mat-row>
    </mat-table>
    <mat-paginator persistPageSize="widgets.scheduled-stream-content-list" [length]="scheduledStreamContentStateTotalCount$ | async" [pageSize]="5" [pageSizeOptions]="[5, 10, 25]"></mat-paginator>
</div>
